import {get, post, put} from "./Http"

export function getUserInfoApi() {
  return get('/ctx-portal/v1/user/current');
}
// 退出登录
export function logoutApi() {
  return post('/ctx-portal/v1/portal/logout', {})
}
//获取用户菜单列表
export function getMenusApi(query) {
  return post('/ctx-portal/v1/rolefunc/findUserRoleFunctionList',query)
}
//获取当前运行版本
export function getRteApi() {
  return get('/ctx-portal/v1/redis/getRte')
}
//获取机构信息
export function getOrgInfoApi(query) {
  return post('/ctx-portal/v1/organization/getForModify', query)
}

//获取教育用户信息
export const getUserInfo = params => {
  return request('/api-sys/sysuser/users/current', params)
}



// WEBPACK FOOTER //
// ./src/api/UserApi.js